import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Container, SectionHeader, Reveal } from './landing/primitives';

const products = [
  { title: 'AI Chat', desc: 'Conversational AI with context awareness, multimodal understanding and natural dialogue.', tag: 'Available', href: '/chat' },
  { title: 'AI Agents', desc: 'Autonomous agents that execute multi-step workflows with precision and reliability.', tag: 'Coming soon' },
  { title: 'AI Workspace', desc: 'A collaborative environment for teams to build, iterate and deploy AI-powered workflows.', tag: 'Coming soon' },
  { title: 'AI Search', desc: 'Semantic search across knowledge bases with instant, cited answers.', tag: 'Coming soon' },
  { title: 'API Platform', desc: 'Production-ready APIs with streaming, function calling and OpenAI-compatible endpoints.', tag: 'Available', href: '/docs' },
  { title: 'Enterprise', desc: 'Dedicated infrastructure, custom deployments and white-label solutions at scale.', tag: 'Contact us', href: '#enterprise' },
];

const Products = () => (
  <section className="py-24 lg:py-32 border-t border-line" id="products" data-testid="products-section">
    <Container>
      <SectionHeader
        eyebrow="Platform"
        title={<>Everything you need<br className="hidden sm:block" /> to build with AI.</>}
        subtitle="A complete suite of AI products and infrastructure designed for developers, teams and enterprises."
      />

      <Reveal delay={0.1} className="mt-16 lg:mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
        {products.map((p, idx) => (
          <a
            key={p.title}
            href={p.href || '#products'}
            className="group relative bg-app p-8 lg:p-10 flex flex-col min-h-[260px] hover:bg-surface-2 transition-colors duration-300"
            data-testid={`product-card-${idx}`}
          >
            <div className="flex items-center justify-between">
              <span className="text-[11px] font-mono text-content-3">0{idx + 1}</span>
              <span className={`inline-flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.18em] ${p.tag === 'Available' ? 'text-content' : 'text-content-3'}`}>
                {p.tag === 'Available' && <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" />}
                {p.tag}
              </span>
            </div>
            <h3 className="mt-auto pt-12 text-2xl font-heading font-medium tracking-tight text-content flex items-center gap-2">
              {p.title}
              <ArrowUpRight className="w-4 h-4 text-content-3 opacity-0 -translate-y-1 translate-x-[-4px] group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-[opacity,transform] duration-300" strokeWidth={1.5} />
            </h3>
            <p className="mt-3 text-content-2 text-sm leading-relaxed">{p.desc}</p>
          </a>
        ))}
      </Reveal>
    </Container>
  </section>
);

export default Products;
